/*
 * File: remote-config.service.ts
 * Project: rast-app
 * Create Date: Wednesday, 1st April 2026
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Wednesday, 1st April 2026
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2026 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

import { Injectable } from '@angular/core';
import { FirebaseRemoteConfig } from '@capacitor-firebase/remote-config';

@Injectable({
  providedIn: 'root'
})
export class RemoteConfigService {

  async fetchAndActivate(): Promise<void> {
    await FirebaseRemoteConfig.fetchAndActivate();
  }

  async getMinimumVersion(): Promise<string> {
    const result = await FirebaseRemoteConfig.getString({ key: 'minimum_version' });
    return result.value ?? '0.0.0';
  }
}
